import type { UseCase } from '@/core/shared'
import type { AuthRepository } from '../domain'

export const doActivateUser: UseCase<AuthRepository, 'activateUser'> = (repository) => {
  return async (activateUser) => {
    await repository.activateUser(activateUser)
  }
}
